import React, { useEffect, useMemo } from 'react';
import { clamp, head, inRange, last, range } from 'lodash';
import classnames from 'classnames';

function PageNumber({ page, active, onPageChange }) {
    return (
        <li className={classnames({ 'uk-active': active })}>
            <button aria-label={`Seite ${page}`} aria-current={active ? "page" : "false"} className="uk-button uk-button-link uk-link-reset" onClick={() => onPageChange(page)} disabled={active}>
                {page}
            </button>
        </li>
    );
}

function Pagination({ itemCount, itemsPerPage, pageRangeDisplayed = 1, selectedPage, onPageChange }) {
    const pageCount = Math.max(Math.ceil(itemCount / itemsPerPage), 1);

    const centerPages = useMemo(() => {
        const clampToPageRange = i => clamp(i, 1, pageCount);
        const center = clamp(selectedPage, clampToPageRange(2 + pageRangeDisplayed), clampToPageRange(pageCount - pageRangeDisplayed - 1));
        return range(center - pageRangeDisplayed-1, center + pageRangeDisplayed + 2).filter(i => inRange(i, 1, pageCount + 1));
    }, [pageCount, pageRangeDisplayed, selectedPage]);

    // const hasStartGap = head(centerPages) > 2;
    // const hasEndGap = last(centerPages) + 1 < pageCount;
    // const showExtraStartPage = head(centerPages) > 1;
    // const showExtraEndPage = last(centerPages) < pageCount;

    useEffect(() => {
        if (selectedPage > pageCount) {
            onPageChange(1);
        }
    });

    const dots = (
        <li className="uk-disabled">
            <span>...</span>
        </li>
    );

    useEffect(() => {
        if (selectedPage > pageCount) {
            onPageChange(1);
        }
    }, [onPageChange, pageCount, selectedPage]);

    return (
        <ul className="uk-pagination uk-flex-center" aria-label="Seitennummerierung">
            <li  className={classnames({ 'uk-disabled': selectedPage === 1 })}>
                <button aria-label="Erste Seite" className="uk-button uk-button-link uk-link-reset" onClick={() => onPageChange(1)} disabled={selectedPage === 1} >
                    <span uk-icon="icon:chevron-double-left; ratio:1.1"></span>
                </button>
            </li>
            <li className={classnames({ 'uk-disabled': selectedPage === 1 })}>
                <button aria-label="Vorherige Seite" className="uk-button uk-button-link uk-link-reset" onClick={() => onPageChange(selectedPage - 1)}
                    disabled={selectedPage === 1}  
                >
                    <span uk-icon="icon:chevron-left; ratio:0.8"></span>                  
                </button>
            </li>
      
            {centerPages.map(page => (
                <PageNumber key={page} page={page} active={page === selectedPage} onPageChange={onPageChange} />
            ))}
            <li className={classnames({ 'uk-disabled': selectedPage === pageCount })}>
                <button
                    aria-label="Nächste Seite"
                    className="uk-button uk-button-link uk-link-reset"
                    onClick={() => onPageChange(selectedPage + 1)}
                    disabled={selectedPage === pageCount}
                > 
                    <span uk-icon="icon:chevron-right; ratio:0.8"></span>
                </button>
            </li>
            <li className={classnames({ 'uk-disabled': selectedPage === pageCount })}>
                <button 
                aria-label="Letzte Seite"
                className="uk-button uk-button-link uk-link-reset" 
                onClick={() => onPageChange(pageCount)}
                disabled={selectedPage === pageCount}>
                    <span uk-icon="icon:chevron-double-right; ratio:1.1"></span>
                </button>
            </li>
        </ul>
    );
}

export default Pagination;
